import React, { useState } from 'react';
import Soundfont from 'soundfont-player';

const RealPiano = () => {
  const [audioCtx, setAudioCtx] = useState(null);
  const [piano, setPiano] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const notes = ['C4', 'D4', 'E4', 'F4', 'G4', 'A4', 'B4', 'C5'];

  const loadAndStart = async () => {
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      await ctx.resume(); // Important for autoplay policy
      const instrument = await Soundfont.instrument(ctx, 'acoustic_grand_piano');
      setAudioCtx(ctx);
      setPiano(instrument);
      setIsLoaded(true);
      console.log("✅ Piano loaded!");
    } catch (error) {
      console.error("❌ Failed to load piano:", error);
    }
  };

  const playNote = (note) => {
    if (!piano) {
      console.warn("Piano not loaded yet.");
      return;
    }

    try {
      piano.play(note);
    } catch (err) {
      console.error(`❌ Error playing ${note}:`, err);
    }
  };

  return (
    <div style={{ textAlign: 'center', marginTop: '40px' }}>
      {!isLoaded ? (
        <button
          onClick={loadAndStart}
          style={{
            padding: '14px 28px',
            fontSize: '18px',
            backgroundColor: '#0b5ed7',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer'
          }}
        >
          🎵 Load Piano
        </button>
      ) : (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '20px' }}>
          {notes.map((note) => (
            <button
              key={note}
              onClick={() => playNote(note)}
              style={{
                width: '60px',
                height: '180px',
                backgroundColor: 'white',
                border: '2px solid black',
                fontSize: '14px',
                cursor: 'pointer',
                borderRadius: '5px',
                boxShadow: '2px 2px 6px rgba(0,0,0,0.3)',
              }}
            >
              {note}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default RealPiano;
